import React from "react";
import { Updater } from "use-immer";

import { IgCheckbox, IgTypography } from "@intelligems/ig-theme";
import { UserBehaviorFilterType } from "@intelligems/ig-types";
import { FormControlLabel, Grid } from "@mui/material";
import { useConfiguration } from "@src/api/configurations/use-configuration";

import { IExperienceDashboardFilters } from "../../../store/types/dashboardFilters";

interface UserBehaviorViewsFilterProps {
  userBehavior: UserBehaviorFilterType;
  setDialogFilters: Updater<IExperienceDashboardFilters>;
}
export const UserBehaviorViewsFilter = ({
  setDialogFilters,
  userBehavior,
}: UserBehaviorViewsFilterProps) => {
  const isHighVolumeAnalytics = useConfiguration("is_high_volume_analytics");
  const onChange = (
    checked: boolean | null,
    filterKey: "viewedProductPage" | "viewedCollectionPage"
  ) => {
    setDialogFilters((draft) => {
      draft.userBehavior[filterKey] = checked ? true : null;
      return draft;
    });
  };
  return (
    <Grid container direction={"column"}>
      {isHighVolumeAnalytics?.value === true ? null : (
        <Grid
          item
          container
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Grid item>
            <Grid item>
              <Grid container>
                <Grid item>
                  <FormControlLabel
                    checked={Boolean(userBehavior.viewedCollectionPage)}
                    control={
                      <IgCheckbox
                        size={"small"}
                        onChange={(e) =>
                          onChange(e.target.checked, "viewedCollectionPage")
                        }
                      />
                    }
                    label={<IgTypography>Visited Collection</IgTypography>}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
      <Grid
        item
        container
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Grid item>
          <Grid container>
            <Grid item>
              <FormControlLabel
                checked={Boolean(userBehavior.viewedProductPage)}
                control={
                  <IgCheckbox
                    size={"small"}
                    onChange={(e) =>
                      onChange(e.target.checked, "viewedProductPage")
                    }
                  />
                }
                label={<IgTypography>Visited Product Page</IgTypography>}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
